<se-fe-modal-button
  class="desktop-header-button"
  [seFeDataButton]="{label: 'Create catalog', primary: false}"
  (seFeButtonAction)="open($event)"
  data-testid="add-catalog-button-desktop"></se-fe-modal-button>

<app-catalog-form-modal
  #catalogFormModal
  modalTitle="Add Catalog"
  savingLabel="Creating catalog"
  [saving]="(creating$ | async) === true"
  [errorMessage]="(error$ | async)?.message ?? ''"
  (save)="createCatalog($event)"></app-catalog-form-modal>
